import React from "react"
import PropTypes from "prop-types"
import { ALL_QUESTIONS, QUESTION_TOPICS, questionsFor } from "../questions"

function QuestionBank({ topicId, question, answeredQuestions, onTopic, onSelect }) {
  const list = questionsFor(topicId)
  const answeredAll = answeredQuestions.filter((item) => ALL_QUESTIONS.indexOf(item) !== -1).length
  const currentRef = React.useRef(null)

  React.useEffect(() => {
    if (currentRef.current && currentRef.current.scrollIntoView) {
      currentRef.current.scrollIntoView({ block: "nearest" })
    }
  }, [question, topicId])

  return (
    <div className="question-bank">
      <div className="question-bank__topics" role="tablist" aria-label="Question topics">
        <button
          type="button"
          role="tab"
          aria-selected={topicId === "all"}
          className={`question-bank__topic${topicId === "all" ? " is-active" : ""}`}
          onClick={() => onTopic("all")}
        >
          All
          <span className="question-bank__count">{answeredAll}/{ALL_QUESTIONS.length}</span>
        </button>
        {QUESTION_TOPICS.map((topic) => {
          const recorded = topic.questions.filter((item) => answeredQuestions.indexOf(item) !== -1).length
          return (
            <button
              key={topic.id}
              type="button"
              role="tab"
              aria-selected={topicId === topic.id}
              className={`question-bank__topic${topicId === topic.id ? " is-active" : ""}`}
              onClick={() => onTopic(topic.id)}
            >
              {topic.label}
              <span className="question-bank__count">{recorded}/{topic.questions.length}</span>
            </button>
          )
        })}
      </div>

      <div className="question-bank__list" role="list">
        {list.map((item) => {
          const answered = answeredQuestions.indexOf(item) !== -1
          const current = item === question
          return (
            <button
              key={item}
              type="button"
              role="listitem"
              ref={current ? currentRef : null}
              className={`question-bank__item${current ? " is-current" : ""}${answered ? " is-answered" : ""}`}
              onClick={() => onSelect(item)}
            >
              <span className="question-bank__prompt">{item}</span>
              <span className="question-bank__status">
                {current ? "Now" : answered ? "Done" : ""}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

QuestionBank.propTypes = {
  topicId: PropTypes.string.isRequired,
  question: PropTypes.string,
  answeredQuestions: PropTypes.arrayOf(PropTypes.string),
  onTopic: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
}

QuestionBank.defaultProps = {
  question: null,
  answeredQuestions: [],
}

export default QuestionBank
